import sizeToGeneralSizeMap, { GeneralSize } from "./centra-size-to-generic-size"

// Create `generalSizeToSizeMap` from `sizeToGeneralSizeMap`
const generalSizeToSizeMap = new Map<GeneralSize, string[]>()

sizeToGeneralSizeMap.forEach((generalSizes, specificSize) => {
    generalSizes.forEach(generalSize => {
        if (!generalSizeToSizeMap.has(generalSize)) {
            generalSizeToSizeMap.set(generalSize, [])
        }
        generalSizeToSizeMap.get(generalSize)!.push(specificSize)
    })
})

// Optional: Sort the specific sizes for each general size
generalSizeToSizeMap.forEach((sizes, generalSize) => {
    sizes.sort()
})

export default generalSizeToSizeMap
